<template>
    <div class="infoGrid">
        <slot></slot>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator';

    @Component
    export default class InfoGrid extends Vue {
    }
</script>

<style lang="scss" scoped>
    .infoGrid {
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: 0.5rem 1rem;
        align-items: center;
    }
</style>
